export const SET_SELECTION = "SET_SELECTION";
export const SET_SELECTION_LOADING = "SET_SELECTION_LOADING";
